// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__gDYM0","wrapperNoHeader":"Layout_wrapperNoHeader__c0yvY","mainContent":"Layout_mainContent__IZl-6"};